<template>
	<div class="w-100 border-semi-grey radius-12">
		<div @click="toggleDetail" class="w-100 position-relative" style="height:145px;">
			<span v-if="is_variant" class="bg-white py-1 px-2 radius-12 body-3-1 position-absolute" style="right:10px;bottom:10px;">{{data.variant_list.length}} Variants</span>
			<span v-if="data.category != null" class="bg-white py-1 px-2 radius-12 body-3-1 position-absolute" style="left:10px;bottom:10px;max-width: 60%;">{{data.category.name}}</span>
			<img :alt="data.name" :src="data.image_url" class="img-fit radius-12-t" />
		</div>
		<div class="p-3 border-bottom-dashed">
			<p class="mb-0 body-1-2">{{data.name}}</p>
			<div class="w-100 no-ws">
				<p 
					v-if="is_variant"
					:class="is_decrease_promo?'w-100' : 'd-inline-block align-middle mr-2'" 
					class="body-3 mb-0" >
					{{$t('hotel.starting-from')}}
				</p>

				<p 
					v-if="is_decrease_promo" 
					class="mb-0 text-line-through body-3 d-inline-block align-middle mr-1">
					{{$formatCurrency(promotion_price)}}
				</p>
				<p 
					class="mb-0 body-1-4 text-orange d-inline-block align-middle"
					:class="{
						'd-inline-block align-middle': is_decrease_promo
					}"
					>
					{{$formatCurrency(final_price)}}
				</p>
			</div>
			<div v-if="page_module == 'general'" class="html-desc text-truncate-2 body-3-3-1 mb-0 mt-2" v-html="data.description">
			</div>
		</div>
		<div class="p-3 d-flex justify-content-between align-items-center">
			<div>
				<div @click="toggleDetail" class="d-table link-green-arrow">
					<p class="mb-0 d-inline-block aling-middle text-12">Read more</p>
					<i class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-10" ></i>
				</div>
			</div>
			<div>
				<button 
					disabled 
					v-if="isNotVoucherAvlb()"
					class="g-btn g-btn-dark g-btn-sm px-3 disabled" 
					>
					Out of stock
				</button>
				<template v-else>
					<button 
						v-if="qty_cart == 0"
						@click="changeQtyProduct('plus')"
						class="g-btn g-btn-secondary g-btn-sm px-3" 
						>
						Select Voucher
					</button>
					<template v-else>
						<button
							v-if="is_variant"
							 @click="toggleVariant()" 
							class="g-btn g-btn-secondary-outline g-btn-sm px-3" >
							{{getVoucherOrder.cart[is_product_in_cart.pos].product[is_product_in_cart.product].variant_list.length}} Variant selected
						</button>
						<div v-else class="w-100 d-flex justify-content-end align-items-center">
							<div class="pos-order-qty bg-orange" @click="changeQtyProduct('minus')">
								<svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M12 1.71429H0V0H12V1.71429Z" fill="white"/>
								</svg>
							</div>
							<p class="mb-0 font-lato text-14 text-center" style="width: 50px;">{{ qty_cart  }}</p>
							<div class="pos-order-qty bg-orange" @click="changeQtyProduct('plus')">
								<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z" fill="white"/>
								</svg>
							</div>
						</div>
					</template>
				</template>
			</div>
		</div>

		<!-- POPUP DETAIL -->
		<b-modal 
      v-model="show_detail"  
      centered 
			size="md" 
			hide-header 
			footer-class="p-0" 
			body-class="p-0">

			<div class="py-3 px-3">
				<div class="w-100 position-relative mb-3">
					<flickity ref="flickity"
						v-if="data.image_list.length > 0"
						:options="$fullSliderOption">
						<div class="carousel-cell w-100" 
							v-for="img in data.image_list">
							<div style="height:270px;" class="w-100">
								<img
									:alt="data.name" 
									:src="img.image_url"
									class="img-fit radius-12">
							</div>
						</div>
					</flickity>
					<div style="height:270px;" v-else>
						<img :alt="data.name" :src="data.image_url" class="img-fit radius-12" />
					</div>

					<div class="bg-white rounded-circle position-absolute border-semi-grey" style="display:inline-flex;padding:10px; right:10px;top:10px;" @click="toggleDetail()">
						<img alt="close-icon" src="../../../assets/img/icon/close.png" width="14" />
					</div>
					<span v-if="data.category != null" class="bg-white py-1 px-2 radius-12 body-3-1 position-absolute" style="left:10px;bottom:10px;">{{data.category.name}}</span>
				</div>
				<div class="w-100 d-block" style="max-height: 300px; overflow-y: auto;">
					<p class="mb-0 body-1-2">{{data.name}}</p>
					<div class="w-100 no-ws mb-3">
						<p 
							v-if="is_variant"
							:class="is_decrease_promo?'w-100' : 'd-inline-block align-middle mr-2'" 
							class="body-3 mb-0" >
							Starting from
						</p>
	
						<p 
							v-if="is_decrease_promo" 
							class="mb-0 text-line-through body-3 d-inline-block align-middle mr-1">
							{{$formatCurrency(promotion_price)}}
						</p>
						<p 
							class="mb-0 body-1-4 text-orange d-inline-block align-middle"
							:class="{
								'd-inline-block align-middle': is_decrease_promo
							}"
							>
							{{$formatCurrency(final_price)}}
						</p>
					</div>
					<div v-if="!(data.description == null || data.description == '')" class="html-desc body-2-2-1 mb-3" v-html="data.description">
					</div>
					<div class="pt-1 mb-4">
						<whatsappLink :name="data.name" :description="$t('hotel.concierge.fitur.ask-the-hotel-about-this-package')" />
					</div>
					<template v-for="(detail,index) in detail_info">
						<div v-if="!(detail.value == null || detail.value == '')" class="rounded-6 mb-3 border bold-shadow px-3">
							<div class="row" data-toggle="collapse" data-target="#what_you_get" aria-expanded="false" aria-controls="what_you_get">
								<div @click="toggleDetailInfo(index)" class="col-10 py-3 align-self-center cursor-pointer">
									<p class="mb-0 body-1-2">{{detail.title}}</p>
								</div>
								<div @click="toggleDetailInfo(index)" class="col-2 text-right align-self-center cursor-pointer">
									<i class="font-weight-bold text-18" :class="detail.show ? 'iconsmind-Arrow-Up' : 'iconsmind-Arrow-Down'" ></i>
								</div>
								<transition name="list">
									<div class="col-12" style="overflow: hidden;" :class="detail.show ? 'show-collapse' : 'hide-collapse'">
										<div class="w-100 border-top-dashed py-3">
											<div class="html-desc body-2-2-1" v-html="detail.value"></div>
										</div>
									</div>
								</transition>
							</div>
						</div>
					</template>
				</div>
			</div>

			<template slot="modal-footer">
				<div class="w-100 py-3">
	    		<div class="px-3" v-if="isNotVoucherAvlb()">
			    	<button
			    		disabled 
							class="g-btn g-btn-dark g-btn-lg w-100 disabled" >
							Out of stock
						</button>
					</div>
					<template v-else>
			    	<div class="px-3" v-if="qty_cart == 0">
				    	<button
				    	 	@click="changeQtyProduct('plus',true)" 
								class="ga-btn-primary-lg" >
								Select Voucher
							</button>
						</div>
						<template v-else>
							<div class="px-3 pt-3" v-if="is_variant">
					    	<button
					    	 	@click="toggleVariant(true)" 
									class="ga-btn-primary-lg" >
									{{getVoucherOrder.cart[is_product_in_cart.pos].product[is_product_in_cart.product].variant_list.length}} Variant selected
								</button>
							</div>
							<div class="row pt-2" v-else>
								<div class="col-12 text-center">
									<p class="body-3-1 mb-1">Selected Voucher</p>
								</div>
								<div class="col-4 offset-4 border-green py-2 radius-6">
									<div class="row no-gutters">
										<div class="col-4 align-self-center text-left">
											<div class="cursor-pointer" @click="changeQtyProduct('minus',true)">
												<img alt="minus-icon" src="../../../assets/img/icon/svg-dec.svg" height="28">
											</div>
										</div>
										<div class="col-4 align-self-center text-center">
											<p class="mb-0 sub-heading-1-2 text-center">{{qty_cart}}</p>
										</div>
										<div class="col-4 align-self-center text-right">
											<div class="cursor-pointer" @click="changeQtyProduct('plus',true)">
												<img alt="plus-icon" src="../../../assets/img/icon/svg-inc.svg" height="28">
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>
					</template>
				</div>
			</template>

		</b-modal>

    <!-- VARIANTS -->
		<b-modal 
      v-model="show_variant"  
      centered 
			size="md" 
			hide-header 
			footer-class="p-0" 
			body-class="p-0">
			<div class="w-100 border-semi-grey p-3 position-relative">
				<div class="d-inline-block align-middle mr-2" style="width: 45px;height:42px;">
					<img :alt="data.name" :src="data.image_url" class="img-fit radius-6">
				</div>
				<div class="d-inline-block align-middle w-75">
					<p class="mb-0 body-1-2">{{data.name}}</p>
					<p class="mb-0 body-2" v-if="data.category != null">{{data.category.name}}</p>
				</div>
				<div class="bg-white rounded-circle position-absolute border-semi-grey" style="display:inline-flex;padding:10px; right:17px;top:21px;" @click="toggleVariant()">
					<img alt="close-icon" src="../../../assets/img/icon/close.png" width="14" />
				</div>
			</div>
			<div class="p-3" :key="variant_detail_key">
				<p class="body-3-1 mb-2">Variant List</p>
				<template v-for="(variant,index) in data.variant_list">
					<VoucherItemVariant 
						@updateQty="updateVariantQty"
						:data="variant"
						:product="data" 
						:is_cart="is_product_in_cart"></VoucherItemVariant>
				</template>
			</div>
    	<template slot="modal-footer">
	    	<div class="p-3 w-100">
		    	<button
		    	 	@click="saveVariantChange()" 
						class="ga-btn-primary-lg" >
						Save Change
					</button>
				</div>
			</template>
		</b-modal>
	</div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
	import VoucherItemVariant from '@/components/hotel/upselling/VoucherItemVariant'
	import {calculateFinalPriceConcierge} from '@/utils/index.js'
  import whatsappLink from '@/components/hotel/concierge/general/whatsappLink';

	export default{
		props:{
			data:{
				type: Object,
				default: () => {} 
			},
			page_module:{
				type: String,
				default: 'general'
			}
		},
		components:{
			VoucherItemVariant,
			whatsappLink			
		},
		data(){
			return{
				show_detail: false,
				detail_info: [],
				show_variant: false,
				variant_detail_key: 0,
				show_variant_from_detail: false,
				variant_update: []
			}
		},
		computed:{
			...mapGetters(['getVoucherOrder']),
			is_addt_srv(){
				return this.page_module == 'additional_service'
			},
			is_variant(){
        return this.data.variant_list.length == 0 ? false : true
      },
      base_price(){
        return this.data.price
      },
      final_price(){
        return calculateFinalPriceConcierge(this.base_price)
      },
      promotion_price(){
        if(this.base_price.promotion_amount == 0){
          return 0
        }else{
          return this.base_price.tax_service_calculation_type == 'INCLUDE' ? this.base_price.price_sell_base : this.base_price.price_sell
        }
      },
      is_decrease_promo(){
        if(this.base_price.promotion_amount == 0){
          return false
        }else{
          return this.base_price.promotion_type == 'INCREASE' ? false : true
        }
      },
			is_product_in_cart(){
				let return_data = {
					pos: -1,
					product: -1,
					product_in_cart: false
				}
      	let pos_i = this.getVoucherOrder.cart.findIndex(el=>el.pos.id == this.data.merchant_pos.id)
      	if(pos_i != -1){
      		return_data.pos = pos_i
      		let product_i = this.getVoucherOrder.cart[pos_i].product.findIndex(el=>el.data.id == this.data.id)
      		if(product_i != -1){
	      		return_data.product = product_i
	      		return_data.product_in_cart = true
      		}
      	}

      	return return_data
      },
			qty_cart(){
        let data = 0
        if(this.is_product_in_cart.product_in_cart){
          data = this.getVoucherOrder.cart[this.is_product_in_cart.pos].product[this.is_product_in_cart.product].qty
        }
        return data
      }
		},
		created(){
			this.fillDetailData()
		},
		methods:{
			...mapMutations(['setVoucherOrder','removeVoucherOrder']),
			toggleDetail(){
				this.show_detail = !this.show_detail
			},
			toggleVariant(from_detail=false){
				this.show_variant = !this.show_variant
				if(this.show_variant){
					this.variant_detail_key++
					if(from_detail){
						this.show_variant_from_detail = true
						this.toggleDetail()
					}
					if(this.is_product_in_cart.product_in_cart && this.is_variant){
						let variant_cart = this.getVoucherOrder.cart[this.is_product_in_cart.pos].product[this.is_product_in_cart.product].variant_list
						this.variant_update = variant_cart.map(el=>{
							delete el.notes
							return el
						})
					}
				}else{
					this.variant_update = []
					if(this.show_variant_from_detail){
						this.toggleDetail()
						this.show_variant_from_detail = false
					}
				}
			},
			fillDetailData(){
				this.detail_info = [
					{
						value: this.data.what_you_get,
						title: 'What you get',
						show: true
					},
					{
						value: this.data.fine_print,
						title: 'Fine print',
						show: false
					},
					{
						value: this.data.how_to_redeem,
						title: 'How to redeem',
						show: false
					},
					{
						value: this.data.cancellation_policy,
						title: 'Cancellation policy',
						show: false
					}
				]
			},
			toggleDetailInfo(index){
				this.detail_info[index].show = !this.detail_info[index].show
			},
			changeQtyProduct(type,from_detail=false){
        if(type == 'plus' && this.is_variant){
          this.toggleVariant(from_detail)
        }else{
          let params = this.generateCartParams(this.data, {}, this.qty_cart)
          if(this.qty_cart == 1 && type == 'minus'){
            this.removeVoucherOrder(params)
          }else{
          	if(this.data.category.code == 'experience'){
          		if(type == 'minus'){
          			if(this.data.min_buy_qty > 1 && params.qty == this.data.min_buy_qty){
	            		params.qty -= this.data.min_buy_qty
	            	}else{
	            		params.qty--
	            	}
	            }else{
	            	if(this.data.availability > params.qty && 
	            			(this.data.max_buy_qty == null || 
	            					(this.data.max_buy_qty != null && 
	            						params.qty < this.data.max_buy_qty)
	            					)
	            			)
	            		{
		            	if(this.data.min_buy_qty > 1 && params.qty == 0){
		            		params.qty += this.data.min_buy_qty
		            	}else{
		            		params.qty++	
		            	}
	            	}
	            }	
          	}else{
          		if(type == 'minus'){
	              params.qty--
	            }else{
	            	if(this.data.availability > params.qty){
	            		params.qty++
	            	}
	            }	
          	}
            if(params.qty == 0){
          		this.removeVoucherOrder(params)
          	}else{
            	this.setVoucherOrder(params)
          	}
          }
        }
      },
      generateCartParams(product, variant, qty){
        let params = {
          product: this.$deepCopy(product),
          variant: this.$deepCopy(variant), 
          qty
        }

        const productMerchantPos = this.$selectActiveMerchantPos(params.product.product_pos_list, this.page_module)
        params.product.product_pos_list = productMerchantPos;
        params.product.product_merchant_pos = productMerchantPos;

        return params;
      },
      updateVariantQty(variant){
      	let variant_i = this.variant_update.findIndex(x=>x.data.id == variant.data.id)
      	if(variant_i != -1){
      		if(variant.qty <= 0){
      			this.variant_update.splice(variant_i,1)
      		}else{
      			this.variant_update.splice(variant_i,1,variant)
      		}
      	}else{
      		this.variant_update.push(variant)
      	}
      },
      saveVariantChange(){
      	if(this.is_product_in_cart.product_in_cart){
      		if(this.variant_update.length == 0){
      			this.updateVariantToVuex('delete')
      		}else{
      			this.updateVariantToVuex('push_delete')
      		}
      	}else{
      		if(this.variant_update.length > 0){
      			this.updateVariantToVuex('push')
      		}else{
      			this.toggleVariant()
      		}
      	}

      	
      },
      updateVariantToVuex(action){
    		if(action == 'push'){
    			this.variant_update.forEach((item,index)=>{
	      		let params = this.generateCartParams(this.data, item.data, item.qty)
	          this.setVoucherOrder(params)
	          if(index+1 == this.variant_update.length){
	          	this.toggleVariant()
	          }
	      	})
    		}else if(action == 'delete'){
    			let variant_cart = this.getVoucherOrder.cart[this.is_product_in_cart.pos].product[this.is_product_in_cart.product].variant_list
    			variant_cart.forEach((item,index)=>{
    				let params = {
	            product: this.data,
	            variant: item.data
	          }
	          this.removeVoucherOrder(params)
	          if(index+1 == variant_cart.length){
	          	this.toggleVariant()
	          }
    			})
    		}else{
    			this.variant_update.forEach((item,index)=>{
	      		let params = this.generateCartParams(this.data, item.data, item.qty)
	          this.setVoucherOrder(params)
	          if(index+1 == this.variant_update.length){
	          	let diff = this.getVoucherOrder.cart[this.is_product_in_cart.pos].product[this.is_product_in_cart.product].variant_list.filter(x=> !this.variant_update.some(y=>x.data.id == y.data.id))
	          	diff.forEach((item_diff,index_diff)=>{
	          		let params = {
			            product: this.data,
			            variant: item_diff.data
			          }
			          this.removeVoucherOrder(params)
			          if(index_diff+1 == diff.length){
			          	this.toggleVariant()
			          }
	          	})
	          	if(diff.length == 0){
	          		this.toggleVariant()
	          	}
	          }
	      	})
    		}
      },
      isNotVoucherAvlb(){
      	if(this.data.variant_list.length == 0){
      		if(this.data.availability == 0){
      			return true
      		}else{
      			if(this.data.category.code == 'experience' && this.data.min_buy_qty > 1 && this.data.availability < this.data.min_buy_qty){
      				return true
      			}else{
      				return false
      			}
      		}
      	}else{
      		let total = 0
      		this.data.variant_list.forEach((variant,index)=>{
      			if(this.data.category.code == 'experience' && variant.min_buy_qty > 1 && variant.availability >= variant.min_buy_qty){
      				return false
      			}
      			total += variant.availability
      			if(index+1 == this.data.variant_list.length){
      				return total > 0 ? false : true
      			}
      		})
      	}
      }
		}
	}
</script>
<style>
	.hide-collapse{
		height: 0px !important;
	}
	.show-collapse{
		height: auto !important;
	}
	.pos-order-qty {
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: grid;
    place-items: center;
    text-align: center;
    border-radius: 6px;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/upselling/VoucherItem.vue